<a class="mb-3 ms-2 inline-icon-with-text" href="" (click)="onBack($event)">
  <om-arrow-left size="xsmall" currentColor="true" [ariaLabel]="'Back button'" inline="true"></om-arrow-left>
  <small class="ms-2">{{ label }}</small>
</a>
